__turbopack_context__.v({
  "bgColorFacebook": "ProfileCompletionModal-module-scss-module__a2oV1q__bgColorFacebook",
  "bgColorGoogle": "ProfileCompletionModal-module-scss-module__a2oV1q__bgColorGoogle",
  "bgColorInstagram": "ProfileCompletionModal-module-scss-module__a2oV1q__bgColorInstagram",
  "bgColorLinkedin": "ProfileCompletionModal-module-scss-module__a2oV1q__bgColorLinkedin",
  "bgColorOffice365": "ProfileCompletionModal-module-scss-module__a2oV1q__bgColorOffice365",
  "bgColorTwitter": "ProfileCompletionModal-module-scss-module__a2oV1q__bgColorTwitter",
  "blocksBackgroundColor": "ProfileCompletionModal-module-scss-module__a2oV1q__blocksBackgroundColor",
  "blocksFontColor": "ProfileCompletionModal-module-scss-module__a2oV1q__blocksFontColor",
  "body": "ProfileCompletionModal-module-scss-module__a2oV1q__body",
  "dialog": "ProfileCompletionModal-module-scss-module__a2oV1q__dialog",
  "fontColorFacebook": "ProfileCompletionModal-module-scss-module__a2oV1q__fontColorFacebook",
  "fontColorGoogle": "ProfileCompletionModal-module-scss-module__a2oV1q__fontColorGoogle",
  "fontColorInstagram": "ProfileCompletionModal-module-scss-module__a2oV1q__fontColorInstagram",
  "fontColorLinkedin": "ProfileCompletionModal-module-scss-module__a2oV1q__fontColorLinkedin",
  "fontColorOffice365": "ProfileCompletionModal-module-scss-module__a2oV1q__fontColorOffice365",
  "fontColorTwitter": "ProfileCompletionModal-module-scss-module__a2oV1q__fontColorTwitter",
  "header": "ProfileCompletionModal-module-scss-module__a2oV1q__header",
  "headerContent": "ProfileCompletionModal-module-scss-module__a2oV1q__headerContent",
  "logo": "ProfileCompletionModal-module-scss-module__a2oV1q__logo",
  "overlay": "ProfileCompletionModal-module-scss-module__a2oV1q__overlay",
  "secondaryNavBackgroundColor": "ProfileCompletionModal-module-scss-module__a2oV1q__secondaryNavBackgroundColor",
  "themeBackgroundColor": "ProfileCompletionModal-module-scss-module__a2oV1q__themeBackgroundColor",
  "themeFontColor": "ProfileCompletionModal-module-scss-module__a2oV1q__themeFontColor",
});
